import { gql } from "@apollo/client";

const NEW_APP_DETAILS = gql`
  mutation NewAppDetails($input: NewAppDetailsInput!) {
    newAppDetails(input: $input) {
      status
      error
      data
    }
  }
`;

export default NEW_APP_DETAILS;

